import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useAuth } from "@bw/shared/hooks";
import { commercialCapabilitiesApi } from "@bw/shared/api";
import type { CommercialCapabilityPage } from "@bw/shared/types/generated";

/** Only verified current actor/org/facility; server owns WorkContext/revision. */
export function useCommercialCapabilities(
  orgId: string | undefined,
  facilityId: string | null,
): UseQueryResult<CommercialCapabilityPage, Error> {
  const { user, loading } = useAuth();
  return useQuery({
    queryKey: ["commercial-capabilities", user?.uid, orgId, facilityId],
    queryFn: () => commercialCapabilitiesApi.get(orgId!, facilityId!),
    enabled: !loading && Boolean(user?.uid && orgId && facilityId),
    retry: false,
  });
}
